import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
// import FranceFlag from './assets/images/icons/france.png'
// import UsaFlag from './assets/images/icons/usa.png'

const LanguageSelect = () => {
  const selected =
    (localStorage.getItem("i18nextLng") === "fr-FR"
      ? "fr"
      : localStorage.getItem("i18nextLng")) || "en";
  const { t } = useTranslation();

  const languageMap = {
    en: { label: t("English"), dir: "ltr", active: true },
    fr: { label: t("French"), dir: "ltr", active: false },
  };

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  React.useEffect(() => {
    document.body.dir = languageMap[selected]?.dir;
  }, [languageMap, menuAnchor, selected]);

  return (
    <div className="language-select-root">
      <Button onClick={({ currentTarget }) => setMenuAnchor(currentTarget)}>
        {/* <img src={FranceFlag} alt="Image langue choisie" className="img-langue-choisie"/> */}
        {languageMap[selected]?.label}
        <ArrowDropDown fontSize="small" />
      </Button>
      <Popover
        open={!!menuAnchor}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div>
          <List>
            <ListSubheader>{t("select_language")}</ListSubheader>
            {Object.keys(languageMap)?.map((item) => (
              <ListItem
                button
                key={item}
                onClick={() => {
                  i18next.changeLanguage(item);
                  setMenuAnchor(null);
                }}
              >
                {languageMap[item]?.label}
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>
    </div>
  );
};

export default LanguageSelect;
